import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-others-list-filters',
  templateUrl: './e-others-list-filters.component.html',
  styleUrls: ['./e-others-list-filters.component.scss'],
  standalone: false
})
export class EOthersListFiltersComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
